import { render, staticRenderFns } from "./AddEditDeclaredValuePackModal.vue?vue&type=template&id=aa5d7322"
import script from "./AddEditDeclaredValuePackModal.vue?vue&type=script&lang=ts"
export * from "./AddEditDeclaredValuePackModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports